import { render, staticRenderFns } from "./CommonStudentForm.vue?vue&type=template&id=4f416b3a&scoped=true&"
import script from "./CommonStudentForm.vue?vue&type=script&lang=js&"
export * from "./CommonStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonStudentForm.vue?vue&type=style&index=0&id=4f416b3a&prod&scoped=true&lang=scss&"
import style1 from "./CommonStudentForm.vue?vue&type=style&index=1&id=4f416b3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f416b3a",
  null
  
)

export default component.exports